import {ServerModalV3} from "../../../helpers/modals/ClassBased/ServerModalV3";
import Axios from "axios";
import handleAjaxError from "../../../helpers/handleAjaxError";
import {NotesDisplay} from "./NotesDisplay";
import {swalConfirm} from "../../../helpers/swalHelper";

// noinspection JSUnusedGlobalSymbols -- Imported via d.ts file
class PersonNotesModal extends ServerModalV3 {
	/** @var {HTMLButtonElement} */
	saveButton;
	/** @var {HTMLTextAreaElement} */
	contentsInput;
	editing = false;
	updateRoute = '';
	skipAutoScroll = false;
	/** @var {HTMLButtonElement} */
	cancelEditButton;

	init() {
		// Init notes display
		const notesDisplayContainer = this.modalContainer.querySelector('.person-notes-display-component');

		new NotesDisplay(notesDisplayContainer, !this.skipAutoScroll);

		// Clear flag
		this.skipAutoScroll = false;

		// Enable notes display controls
		notesDisplayContainer.querySelectorAll('.edit-controls').forEach(controls => {
			controls.classList.remove('d-none');
		})

		// Setup events for note controls
		notesDisplayContainer.querySelectorAll('.remove-button').forEach(button => {
			button.addEventListener('click', () => {
				this.handleRemoveNote(button.dataset.route);
			})
		})
		notesDisplayContainer.querySelectorAll('.edit-button').forEach(button => {
			button.addEventListener('click', () => {
				const contentContainer = button.closest('.note-container').querySelector('.content');

				this.handleEditNote(button.dataset.route, contentContainer.innerText);
			})
		})

		// Setup cancel edit button
		this.cancelEditButton = this.modalContainer.querySelector('.cancel-edit-button');
		this.cancelEditButton.addEventListener('click', () => {
			this.handleCancelEditRequest();
		})

		// Init store button
		this.saveButton = this.modalContainer.querySelector('.save-button');
		this.contentsInput = this.modalContainer.querySelector('textarea');

		this.saveButton.addEventListener('click', () => {
			this.saveNote();
		});
	}

	saveNote() {
		let postRoute;
		if (this.editing) {
			postRoute = this.updateRoute
			this.skipAutoScroll = true;
		} else {
			postRoute = this.saveButton.dataset.route;
		}

		if (this.contentsInput.value.trim() === '') {
			// Do nothing
			return;
		}

		this.showLoadingInModal();

		Axios.post(postRoute, {
			contents: this.contentsInput.value,
		})
			.then(() => {
				// noinspection JSIgnoredPromiseFromCall
				this.refreshModalFromServer({
					inPlace: true,
					preserveScroll: true,
				});

				this.editing = false;

				// Notify any listener
				this.notifySuccessListeners();
			})
			.catch(handleAjaxError)
			.finally(() => {
				this.hideLoadingInModal();
			})
	}

	handleRemoveNote(route) {
		swalConfirm({
			title: 'Are you sure you want to remove this note?',
		})
			.then(result => {
				if (result.isConfirmed) {
					this.showLoadingInModal();
					Axios.post(route)
						.then(() => {
							// Set flag to prevent scroll down from container
							this.skipAutoScroll = true;
							// noinspection JSIgnoredPromiseFromCall
							this.refreshModalFromServer({
								inPlace: true,
								preserveScroll: true,
							});

							// Notify any listener
							this.notifySuccessListeners();
						})
						.catch(handleAjaxError)
						.finally(() => {
							this.hideLoadingInModal()
						})
				}
			})
	}

	handleEditNote(route, contents) {
		this.editing = true;
		this.updateRoute = route;

		this.contentsInput.value = contents;

		this.render();
	}

	handleCancelEditRequest() {
		this.editing = false;
		this.skipAutoScroll = false;
		this.contentsInput.value = '';

		this.render();
	}

	render() {
		// Make or hide cancel edit button
		if (this.editing) {
			this.cancelEditButton.classList.remove('d-none')
		} else {
			this.cancelEditButton.classList.add('d-none')
		}
	}
}

export {PersonNotesModal}

